// SocketContext.ts
import { createContext } from "react";
import { Socket } from "socket.io-client";

export type SocketConnectionStatus =
  | "idle"
  | "connecting"
  | "connected"
  | "disconnected";

interface SocketContextType {
  socket: Socket;
  serverReady: boolean;
  connectionStatus: SocketConnectionStatus;
}

export const SocketContext = createContext<SocketContextType | null>(null);
